import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
const _excluded = ["children", "id", "label"];
import { cloneElement } from 'react';
import useUniqueId from 'react-utils/hooks/useUniqueId';
import styled from 'styled-components';
import { filterProps } from '../../../utils';
import { useMapStylePropsToCSS } from '../../../hooks/useMapStylePropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledInlineLabel = styled.label.withConfig({
  displayName: "InlineLabel__StyledInlineLabel",
  componentId: "sc-1u8tqvm-0"
})(props => {
  const _ref = props.$cssStyles,
    $cssStyles = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const theme = props.theme;
  return Object.assign({
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: theme.space['300']
  }, $cssStyles);
});
const StyledLabelText = styled.div.withConfig({
  displayName: "InlineLabel__StyledLabelText",
  componentId: "sc-1u8tqvm-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    flexShrink: '0',
    marginRight: theme.space['200'],
    userSelect: 'none'
  };
});
export const InlineLabel = _ref2 => {
  let {
      children,
      id,
      label
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const defaultId = useUniqueId(`uiinlinelabel-`);
  const computedId = id || defaultId;
  const {
    styleProps
  } = filterProps(rest);
  const cssStyles = useMapStylePropsToCSS(styleProps);
  return /*#__PURE__*/_jsxs(StyledInlineLabel, Object.assign({}, rest, {
    id: computedId,
    $cssStyles: cssStyles,
    children: [/*#__PURE__*/_jsx(StyledLabelText, {
      children: label
    }), /*#__PURE__*/cloneElement(children, {
      'aria-labelledby': computedId
    })]
  }));
};